import xlsx, { ISettings, IJsonSheet, IColumn, IContent } from "json-as-xlsx";
import { CategoriaFinanceiraItem } from "features/condominio/hooks/useListFinancialCategory";
import { defaultContentMapperXlsx } from "infra/packages/json-as-xlsx";
import { TenantMeResponse } from "core/features/auth/typings/user";

export function renameBreadCrumbsAndOrder(data: CategoriaFinanceiraItem[]) {
  function recreateBreadCrumb(item: CategoriaFinanceiraItem) {
    item.items?.forEach((v, i) => {
      v.breadcrumb = "";
      v.breadcrumb = item.breadcrumb + `.${i + 1}`;
      v.ordem = i;
      if (v.items) {
        recreateBreadCrumb(v);
      }
    });
  }

  data.forEach(recreateBreadCrumb);
}

export function searchCategoryItem(
  element: CategoriaFinanceiraItem,
  matchingId: string
): CategoriaFinanceiraItem | null {
  if (element.id === matchingId) {
    return element;
  } else if (element.items?.length) {
    var i;
    var result = null;
    for (i = 0; result === null && i < element.items.length; i++) {
      result = searchCategoryItem(element.items[i], matchingId);
    }
    return result;
  }
  return null;
}

export function planifyCategoriasFinanceiras(
  data: CategoriaFinanceiraItem[]
): CategoriaFinanceiraItem[] {
  return data.reduce<CategoriaFinanceiraItem[]>((acc, item) => {
    const flattenedItems = item.items
      ? planifyCategoriasFinanceiras(item.items)
      : [];

    return [...acc, item, ...flattenedItems];
  }, []);
}

export function exportExcelPlanoContas({
  data,
  currentTenant,
}: {
  data: CategoriaFinanceiraItem[];
  currentTenant: TenantMeResponse;
}) {
  const planifiedData = planifyCategoriasFinanceiras(data);

  const settings: ISettings = {
    fileName: currentTenant
      ? `Plano de Contas - ${currentTenant.nome}`
      : `Plano de Contas`,
    extraLength: 3,
    writeOptions: {},
  };

  const columns = getColumnsPlanoContas();

  const sheets: IJsonSheet[] = [];

  sheets.push({
    sheet: `Plano de Contas`,
    columns: columns,
    content: planifiedData.map(defaultContentMapperXlsx),
  });

  xlsx(sheets, settings);
}

function getColumnsPlanoContas() {
  const columns: IColumn[] = [];

  columns.push({
    label: "Categoria",
    value: (row: IContent) =>
      `${(row as unknown as CategoriaFinanceiraItem).breadcrumb} ${
        (row as unknown as CategoriaFinanceiraItem).nome
      }`,
  });

  columns.push({
    label: "Centro de Custo",
    value: (row: IContent) =>
      (row as unknown as CategoriaFinanceiraItem).centroDeCusto?.nome || "",
  });

  columns.push({
    label: "Código de Integração",
    value: (row: IContent) =>
      (row as unknown as CategoriaFinanceiraItem).codigoIntegracao || "",
  });

  columns.push({
    label: "Status",
    value: (row: IContent) =>
      (row as unknown as CategoriaFinanceiraItem).ativo ? "Ativo" : "Inativo",
  });

  return columns;
}
